import { Visibility } from '@nextforce/api'
import { ListItem, makeStyles } from '@rneui/themed'
import { t } from 'app/i18l'
import React, { useCallback, useState } from 'react'
import { Collapsible } from 'shared/components/list/collapsible'

interface Props {
  title: string
  value: Visibility | undefined
  items: Visibility[]
  stores: number
  setVisiblity(value: Visibility): void
  required?: boolean
}

export function VisibilityChooser({
  title,
  value,
  items,
  setVisiblity,
  required,
  stores,
}: Props) {
  const styles = useStyles()
  const [expanded, setExpanded] = useState(!!required && !value)

  const toggle = useCallback(
    (item: Visibility) => {
      setVisiblity(item)
      setExpanded(false)
    },
    [setVisiblity]
  )

  return (
    <Collapsible
      title={title}
      value={
        value?.role === 'ALL'
          ? t('everyone')
          : value
          ? t(value.titleKey)
          : undefined
      }
      expanded={expanded}
      onPress={() => setExpanded(!expanded)}
      required={required}
    >
      {items.map((item, index) => (
        <ListItem key={index} onPress={() => toggle(item)} bottomDivider>
          <ListItem.Content>
            <ListItem.Title style={styles.option}>
              {item.role === 'ALL' ? t('everyone') : t(item.titleKey)}
            </ListItem.Title>
          </ListItem.Content>
          <ListItem.CheckBox
            checked={item.titleKey === value?.titleKey}
            checkedColor={styles.checkboxChecked.color}
            uncheckedColor={styles.checkboxUnchecked.color}
            checkedIcon="check"
            uncheckedIcon=""
            onPress={() => {
              toggle(item)
            }}
          />
        </ListItem>
      ))}
    </Collapsible>
  )
}

export const useStyles = makeStyles(theme => ({
  option: {
    marginHorizontal: 15,
    color: theme.colors?.grey2,
  },
  checkboxChecked: {
    color: theme.colors?.primary,
  },
  checkboxUnchecked: {
    color: theme.colors?.grey5,
  },
}))
